import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { debounce, takeUntil } from 'rxjs/operators'
import { interval, Subject } from 'rxjs'

@Component({
  selector: 'mb-mpup-search',
  templateUrl: './mpup-search.component.html',
  styleUrls: ['./mpup-search.component.scss']
})
export class MpupSearchComponent implements OnInit, OnDestroy {

  @Input()
  placeholder!: string

  @Output()
  search = new EventEmitter<string>()
  searchString = new FormControl('', { nonNullable: true })
  private unsubscribe$ = new Subject<void>()

  ngOnInit (): void {
    this.searchString.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        debounce(() => interval(500))
        ).subscribe({
      next: (searchTerm) => this.onSearch(searchTerm)
    })
  }

  ngOnDestroy () {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  onSearch (searchTerm: string): void {
    this.search.emit(searchTerm)
  }

}
